<template>
  <router-view />
  
  <!-- Chat widget appears site-wide as corner widget -->
  <ChatWidget 
    :show-welcome-message="false"
    :auto-show-delay="0"
    theme="branded"
    position="bottom-right"
    @close="handleChatWidgetClose"
  />
</template>

<script>
import ChatWidget from '@/components/chat/ChatWidget.vue';

export default {
  name: 'App',
  components: {
    ChatWidget
  },
  methods: {
    handleChatWidgetClose() {
      if (window.$chatwoot) {
        window.$chatwoot.toggle("close");
      }
    }
  }
}
</script> 